import Cookies from 'js-cookie';

const FIRST_TOUCH_URL_COOKIE_NAME = 'firstTouchUrl';
const FIRST_TOUCH_URL_TTL_DAYS = 3;
// Cookies cap out around 4KB; skip rather than silently truncate a long URL.
const MAX_URL_LENGTH = 2000;

// Captures the first URL visited, once, for FIRST_TOUCH_URL_TTL_DAYS.
export const captureFirstTouchUrl = () => {
  try {
    if (Cookies.get(FIRST_TOUCH_URL_COOKIE_NAME)) return;

    const url = window.location.href;
    if (url.length > MAX_URL_LENGTH) return;

    Cookies.set(FIRST_TOUCH_URL_COOKIE_NAME, url, {
      expires: FIRST_TOUCH_URL_TTL_DAYS,
      path: '/',
      sameSite: 'Lax',
    });
  } catch {
    // cookies unavailable/blocked; skip capture
  }
};

export const getFirstTouchUrl = (): string | undefined => {
  try {
    return Cookies.get(FIRST_TOUCH_URL_COOKIE_NAME);
  } catch {
    return undefined;
  }
};
